import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { reaction } from "mobx";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { Button, Utils } from "arv-reactcomponents";
import { scrollTime, LISTING } from "npmlinks-constants";
import { somethingWentWrong, clearedUrl } from "../../../utils";
import BodyOverlay from "../../BodyOverlay";
import { isApplyButtonDisabled, isClearAllButtonDisabled } from "./methods";

@withRouter
@inject("ProductStore")
@observer
class ApplyCancelButton extends Component {
  constructor() {
    super();
    this.apply = this.apply.bind(this);
    this.clearAll = this.clearAll.bind(this);
    this.triggerReaction = this.triggerReaction.bind(this);
  }
  componentDidMount() {
    this.triggerReaction();
  }

  triggerReaction() {
    reaction(
      () => this.props.ProductStore.triggerMobileApply,
      value => {
        if (value) {
          this.props.ProductStore.triggerMobileApplyCall(false);
          this.apply();
        }
      },
    );
  }
  get applyButtonDisabled() {
    return isApplyButtonDisabled(
      window.location.search,
      this.props.ProductStore.mobileTempUrlCache.search,
    );
  }
  get clearAllButtonDisabled() {
    return isClearAllButtonDisabled(
      window.location.search,
      this.props.ProductStore.mobileTempUrlCache.search,
    );
  }
  clearAll(event) {
    if (event) {
      event.preventDefault();
    }
    BodyOverlay.component.show();
    const { pathname, search } = window.location;
    const { ProductStore } = this.props;
    ProductStore.storeTempUrl("", "");
    ProductStore.clearTempFilters();
    const newUrl = clearedUrl(pathname, search);
    ProductStore.getAllProductData(newUrl).then(
      () => {
        Utils.scrollTo(window, 0, 100, scrollTime.fast);
        BodyOverlay.component.hide();
      },
      () => {
        BodyOverlay.component.hide();
        somethingWentWrong();
      },
    );
    const state =
      (this.props.history &&
        this.props.history.location &&
        this.props.history.location.state) ||
      {};
    this.props.history.replace(newUrl, state);
    // this.props.ProductStore.toggleMobileFilters(
    //   this.props.ProductStore.mobileFilterToggle.activeFilter,
    // );
  }
  apply(event) {
    if (event) {
      event.preventDefault();
    }
    const { ProductStore } = this.props;
    const location = ProductStore.mobileTempUrlCache;
    const { pathname, search } = location;
    const pagePath = `${pathname}${search}`;
    BodyOverlay.component.show();
    ProductStore.clearTempFilters();
    ProductStore.getAllProductData(pagePath).then(
      () => {
        Utils.scrollTo(window, 0, 100, scrollTime.fast);
        BodyOverlay.component.hide();
      },
      () => {
        BodyOverlay.component.hide();
        somethingWentWrong();
      },
    );
    const state =
      (this.props.history &&
        this.props.history.location &&
        this.props.history.location.state) ||
      {};
    this.props.history.replace(pagePath, state);
    this.props.ProductStore.toggleMobileFilters(
      this.props.ProductStore.mobileFilterToggle.activeFilter,
    );
  }
  render() {
    return (
      <div className="nw-mobilefilters-applicancelbutton">
        <Button
          disabled={this.clearAllButtonDisabled}
          onClick={event => this.clearAll(event)}
          className="nw-mobilefitlers-clearapply clearbutton"
        >
          {LISTING.APPLY_CANCEL_BUTTON.CANCEL}
        </Button>
        <Button
          disabled={this.applyButtonDisabled}
          onClick={event => this.apply(event)}
          className="nwc-btn-primary nw-mobilefitlers-clearapply applybutton"
        >
          {LISTING.APPLY_CANCEL_BUTTON.APPLY}
        </Button>
      </div>
    );
  }
}

ApplyCancelButton.wrappedComponent.propTypes = {
  ProductStore: PropTypes.shape({
    triggerMobileApplyCall: PropTypes.func.isRequired,
    triggerMobileApply: PropTypes.bool.isRequired,
    toggleMobileFilters: PropTypes.func.isRequired,
    mobileFilterToggle: PropTypes.shape({
      activeFilter: PropTypes.string.isRequired,
    }).isRequired,
    mobileTempUrlCache: PropTypes.shape({
      search: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    location: PropTypes.shape({
      state: PropTypes.shape({}).isRequired,
    }).isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ProductStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ApplyCancelButton.wrappedComponent,
  component: ApplyCancelButton,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MobileFilters/ApplyCancelButton/index.js